<div class="next-task">
  <div class="title">
    <h4>PROCHAINE(S) INTERVENTION(S)</h4>
  </div>

  <div class="interventions">
    <div *ngFor="let date of dates" class="date">
      <div class="date-libelle">
        <p>{{ formatDateTask(date.date_session) | titlecase }}</p>
      </div>

      <div class="bloc-session" *ngFor="let session of date.liste_sessions">
        <div class="bloc-description">
          <p class="nom">{{ session.titre_session }}</p>
          <p class="code-interne" *ngIf="session.sous_titre_session">{{ session.sous_titre_session }}</p>
          <p class="numero">{{ session.reference_session }}</p>
        </div>

        <div class="bloc-info">
          <div class="flex">
            <i class="material-icons">
              access_time
            </i>
            <p>{{ session.horaires_session }}</p>
          </div>

          <div class="flex" *ngFor="let site of session.liste_sites">
            <i class="material-icons">
              location_on
            </i>
            <p>
              {{ site.libelle }}<br />
              <span class="adresse-site">{{ site.adresse }}, {{ site.cp }} {{ site.ville }}</span>
            </p>
          </div>

          <div class="flex">
            <i class="material-icons">
              person
            </i>
            <p>{{ session.nb_apprenants }} apprenant(s)</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
